import { Component } from '@angular/core';
import { soundpostPostingGroupEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Posting Groups') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostpostinggroup-form',
    templateUrl: './soundpostpostinggroup.form.component.html'
})
export class soundpostPostingGroupFormComponent extends BaseFormComponent {
    public record!: soundpostPostingGroupEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'postingGroupLines', sectionName: 'Posting Group Lines', isExpanded: false },
            { sectionKey: 'accountingEntries', sectionName: 'Accounting Entries', isExpanded: false }
        ]);
    }
}

